import { translateText } from "../../../helpers/LanguageHelper";
import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Row, Col } from "reactstrap";
import ProductBox from "./ProductBox";
import Skeleton from "./Skeleton/Skeleton";
import { useSelector, useDispatch } from 'react-redux';

import { getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen } from "../../../helpers/CommonHelper";
import Config from "../../../helpers/Config";
import { MakeApiCallAsync } from "../../../helpers/ApiHelpers";
import GlobalEnums from "../../../helpers/GlobalEnums";
import rootAction from "../../../stateManagment/actions/rootAction";
import { LOADER_DURATION } from "../../../helpers/Constants";



const NewProducts = ({ effect }) => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("best sellers");
    const [collection, setCollection] = useState([
        {
            nameEn: "new products",
            icon: "fa-star",
            caption: "Fresh arrivals",
            nameAr: "منتجات جديدة"
        },
        {
            nameEn: "best sellers",
            displayName: "fast moving",
            icon: "fa-trophy",
            caption: "Selling quickly",
            nameAr: "أفضل البائعين"
        },
        {
            nameEn: "on sale",
            icon: "fa-tag",
            caption: "Save more",
            nameAr: "للبيع"
        },
        {
            nameEn: "hotdeal",
            icon: "fa-fire",
            caption: "Limited offers",
            nameAr: "صفقة حاسمة"
        }
        

    ]);

    const [ProductsList, setProductsList] = useState([]);
    const [langCode, setLangCode] = useState('');
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const [PaginationInfo, setPaginationInfo] = useState({
        PageNo: 1,
        PageSize: 20,
        TotalRecords: 0
    });



    const getNewProductsList = async (TabName) => {

        await setActiveTab(TabName);
        //--empty list of product
        await setProductsList([]);

        const headers = {

            Accept: 'application/json',
            'Content-Type': 'application/json',

        }


        const param = {
            requestParameters: {
                PageNo: PaginationInfo.PageNo,
                PageSize: PaginationInfo.PageSize,
                TabName: TabName,
                recordValueJson: "[]",
            },
        };



        const response = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_RECENTS_PRODUCTS_LIST'], null, param, headers, "POST", true);
        if (response != null && response.data != null) {

            let ProductData = JSON.parse(response.data.data);
            await setProductsList(ProductData);


        }
    }



    useEffect(() => {
        // declare the data fetching function
        const dataOperationInUseEffect = async () => {

            //--Get language code
            let lnCode = getLanguageCodeFromSession();
            await setLangCode(lnCode);


            await getNewProductsList("best sellers");
            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["NewProducts"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }





        }

        //--start loader
        dispatch(rootAction.commonAction.setLoading(true));

        // call the function
        dataOperationInUseEffect().catch(console.error);

        //--stop loader
        setTimeout(() => {
            dispatch(rootAction.commonAction.setLoading(false));
        }, LOADER_DURATION);

    }, [])



    return (
        <>

            <section className="section-pt-space ukl-new-products-tabs">
                <div className="tab-product-main">
                    <div className="tab-prodcut-contain">
                        <div className="ukl-our-products-title">
                            <span className="ukl-our-products-title__icon"><i className="fa fa-shopping-basket" /></span>
                            <div>
                                <h2>{translateText("Our Products")}</h2>
                                <p>{translateText("Fresh Uthukuli favourites, selected for you")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-py-space ratio_asos product ukl-new-products-grid">
                <div className="custom-container">
                    <Row>
                        <Col className="pe-0">
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId={activeTab}>

                                    {!ProductsList || ProductsList.length < 0 ? (
                                        <Skeleton />
                                    ) : (
                                        <>
                                            <div className="product product-grid-vertical product-m">
                                                <Row className="ukl-product-row">
                                                    {ProductsList && ProductsList.map((itm, i) => (
                                                        <Col xs="6" md="4" lg="3" xl="3" key={i} className="ukl-product-column">
                                                            <ProductBox
                                                                hoverEffect={effect}
                                                                item={itm}
                                                                layout=""
                                                                ProductDetailPageForceUpload={false}
                                                                fitImage={true}
                                                            />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        </>
                                    )}

                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default NewProducts;
